<template>
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45 24.1071C44.1749 35.7835 34.4293 45 22.5283 45C10.0863 45 0 34.9264 0 22.5C0 10.0736 10.0863 0 22.5283 0C34.4293 0 44.1749 9.21652 45 20.8929H41.7722C40.9545 10.9936 32.651 3.21429 22.5283 3.21429C11.8637 3.21429 3.21833 11.8488 3.21833 22.5C3.21833 33.1512 11.8637 41.7857 22.5283 41.7857C32.651 41.7857 40.9545 34.0064 41.7722 24.1071H45Z"
      fill="url(#paint0_angular)"
    />
    <defs>
      <radialGradient
        id="paint0_angular"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(43.7156 22.5) rotate(-180) scale(41.7042 41.5995)"
      >
        <stop offset="0.249782" :stop-color="color" />
        <stop offset="0.747723" :stop-color="color" />
      </radialGradient>
    </defs>
  </svg>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'LoadingCircle',
  components: {},
  setup() {
    const store = useStore();
    const color = computed(() => store.getters.getColor(1) || '#008CD6');

    return {
      color,
    };
  },
};
</script>
<style lang="scss" scoped></style>
